module.exports = __webpack_public_path__ + "static/media/Univers.c30475a4.woff2";